export const environment = {
    production: false,
    clientId: '84b5e3d1-9152-4ec7-977c-eb187d0255b3',
    clientKey: 'rFOZReUZ5Ld97pSbEbIhRLbzyKs=',
    appId: '1cdc6bf0-b887-11eb-8529-0242ac130003',
    tenantUrl: 'https://tl-b.gooru.org/',
    tenantImage: '`https://cdn.gooru.org/',
    appConfig: {
      apiUrl: 'https://prodb.gooru.org',
      cdnUrls: {
        contentUrl: 'https://cdn.stage.gooru.org',
        userUrl: 'https://cdn.stage.gooru.org'
      },
      parse: {
        apiPath: 'mygooru/parse',
        appId: '1cdc6bf0-b887-11eb-8529-0242ac130003',
        xParseAppId: 'MyGooru'
      },
      deviceType: 'web'
    },
    testAccount: {
      email: "developer@goorulearning.com"
    }
  };